var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPresentAddress(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 8C13.6 8 10 11.6 10 16C10 21.4 17 27.5 17.3 27.8C17.5 27.9 17.8 28 18 28C18.2 28 18.5 27.9 18.7 27.8C19 27.5 26 21.4 26 16C26 11.6 22.4 8 18 8ZM18 25.7C15.9 23.7 12 19.4 12 16C12 12.7 14.7 10 18 10C21.3 10 24 12.7 24 16C24 19.3 20.1 23.7 18 25.7ZM18 12C15.8 12 14 13.8 14 16C14 18.2 15.8 20 18 20C20.2 20 22 18.2 22 16C22 13.8 20.2 12 18 12ZM18 18C16.9 18 16 17.1 16 16C16 14.9 16.9 14 18 14C19.1 14 20 14.9 20 16C20 17.1 19.1 18 18 18Z",
    fill: "#2C25C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresentAddress);
export default __webpack_public_path__ + "static/media/present-address.b3fcb420419dd4978793d2f9c919aa23.svg";
export { ForwardRef as ReactComponent };